import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';

const useValidationSchema = () => {
  const { notFuture, required } = useValidators();

  const nameSchema = yup.object().shape({
    family: required(yup.string()),
    given: yup.array().of(yup.string()).nullable(),
    prefix: yup.array().of(yup.string()).nullable(),
    suffix: yup.array().of(yup.string()).nullable(),
    text: yup.string().nullable(),
  });

  const identifierSchema = yup.object().shape({
    use: yup.string().nullable(),
    uiSystemType: yup.string().nullable(),
    system: yup.string().nullable(),
    oid: yup.string().when('uiSystemType', {
      is: 'other',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable(),
    }),
    value: yup.string().when('uiSystemType', {
      is: (val: string | undefined) => !!val,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable(),
    }),
    type: yup.string().nullable(),
  });

  const telecomSchema = yup.object().shape({
    system: yup.string().nullable(),
    value: yup.string().nullable(),
    use: yup.string().nullable(),
    rank: yup.number().nullable(),
  });

  const addressSchema = yup.object().shape({
    use: yup.string().nullable(),
    type: yup.string().nullable(),
    line: yup.array().of(yup.string()).nullable(),
    city: yup.string().nullable(),
    district: yup.string().nullable(),
    state: yup.string().nullable(),
    postalCode: yup.string().nullable(),
    country: yup.string().nullable(),
  });

  const FormSchema = yup.object().shape({
    name: yup.array().of(nameSchema).min(1).required(),
    identifier: yup.array().of(identifierSchema).nullable(),
    telecom: yup.array().of(telecomSchema).nullable(),
    address: yup.array().of(addressSchema).nullable(),
    birthDate: notFuture(yup.date()).nullable(),
    organizationIds: yup.array().of(yup.object()).nullable(),
    active: yup.boolean().default(true),
  });

  return { FormSchema };
};

export default useValidationSchema;
